import React from 'react';
import { Section, Stack } from '@fiverr-private/layout_components';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { I18n } from '@fiverr-private/i18n-react';
import { Carousel, Arrows, Track, Slide } from '@fiverr-private/carousel';
import SafeComponent from '../../shared/SafeComponent';
import { CLICKED_SUBCATEGORY_ARROW, MP_CAROUSEL_CLICKED } from '../../utils/biEvents/events/mixPanelEvents';
import { getImpressionEnrichment, sendMixPanelEvent } from '../../utils/biEvents';
import { BQ_IMP_POPULAR_SERVICES_CAROUSEL_IS_SHOWN } from '../../utils/biEvents/events/bigQueryEvents';
import SubCategory from './SubCategory';
import { SubCategoryData } from './types';

import styles from './index.module.scss';

const SUBCATEGORY_BREAKPOINTS = { default: 1, sm: 2, md: 3, lg: 4 };

interface NewSubcategoryCarouselProps {
    subCategories: SubCategoryData[];
}

const NewSubcategoryCarousel = ({ subCategories }: NewSubcategoryCarouselProps) => {
    const [ref] = useImpressionItem(getImpressionEnrichment({ eventName: BQ_IMP_POPULAR_SERVICES_CAROUSEL_IS_SHOWN }));

    const handleOnArrowClick = ({ direction }) => {
        sendMixPanelEvent({ eventName: MP_CAROUSEL_CLICKED, params: { element: direction } });
        sendMixPanelEvent({ eventName: CLICKED_SUBCATEGORY_ARROW });
    };

    return (
        <Section paddingTop={{ default: '8', md: '10' }} paddingBottom={{ default: '8', md: '10' }}>
            <Stack direction="column" gap={{ default: '3', md: '8' }} ref={ref}>
                <h2 className="h2-title">
                    <I18n k="logged_out_homepage.subcategory_carousel.title" />
                </h2>
                <Carousel breakpoints={SUBCATEGORY_BREAKPOINTS} scrollType="row" swipeModeDevice="tablet">
                    <Arrows onArrowClick={handleOnArrowClick as any} />
                    <Track autoSlidesWidth slidesGap="4">
                        {subCategories.map((subCategory, index) => (
                            <Slide key={subCategory.subCategoryId ?? index} className={styles.slide}>
                                <SubCategory {...subCategory} index={index} />
                            </Slide>
                        ))}
                    </Track>
                </Carousel>
            </Stack>
        </Section>
    );
};

export { NewSubcategoryCarousel };
export default SafeComponent(NewSubcategoryCarousel);
